module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pm-f290a4bcb2060c82a15c08a34dba04e2.svg";